import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {ConstructionHelmetIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

interface Props {
    onButtonClick: () => void;
    type: "property" | "offer";
}

export const DetailConstructionGallerySection = (props: Props) => {
    const {isMobile} = useUserDevice();
    const isProperty = props.type === "property";

    return (
        <div css={detailConstructionSectionContainer} data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_CONSTRUCTION_PHOTOS_SECTION}>
            <ConstructionHelmetIcon wrapperColor="var(--colors-primary)" size="7" wrapperSize="8" />
            <div css={[detailConstructionBox, isProperty && propertyStyle]}>
                <div css={textContainer}>
                    <Text variant="headline_2" css={textStyle}>
                        {isMobile ? "Postępy i zdjęcia z budowy" : "Zdjęcia z budowy"}
                    </Text>
                    <Text variant="body_copy_0" css={textStyle}>
                        Zobacz na jakim etapie budowy jest ta inwestycja
                    </Text>
                </div>
                <Button
                    variant="filled_primary"
                    onClick={() => {
                        props.onButtonClick();
                    }}
                    css={buttonStyle}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.SEE_CONSTRUCTION_STEPS_BUTTON}
                >
                    Zobacz etapy budowy
                </Button>
            </div>
        </div>
    );
};

const detailConstructionSectionContainer = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: calc(var(--globals-baseUnit) * 3);
    background-color: #fff;
    border-radius: var(--globals-baseUnit);
    padding: calc(var(--globals-baseUnit) * 2);

    @media (min-width: ${theme.breakpoints.sm}) {
        flex-direction: row;
        padding: calc(var(--globals-baseUnit) * 3);
    }
`;

const detailConstructionBox = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: calc(var(--globals-baseUnit) * 3);

    @media (min-width: ${theme.breakpoints.sm}) {
        flex-direction: row;
    }
`;

const propertyStyle = css`
    @media (min-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const textContainer = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    gap: calc(var(--globals-baseUnit) * 3);

    @media (min-width: ${theme.breakpoints.sm}) {
        gap: calc(var(--globals-baseUnit) * 1);
    }
`;

const textStyle = (theme: Theme) => css`
    text-align: center;
    @media (min-width: ${theme.breakpoints.sm}) {
        text-align: left;
    }
`;

const buttonStyle = (theme: Theme) => css`
    width: 100%;
    @media (min-width: ${theme.breakpoints.sm}) {
        width: auto;
    }
`;
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {ConstructionHelmetIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

interface Props {
    onButtonClick: () => void;
    type: "property" | "offer";
}

export const DetailConstructionGallerySection = (props: Props) => {
    const {isMobile} = useUserDevice();
    const isProperty = props.type === "property";

    return (
        <div css={detailConstructionSectionContainer} data-testid={OFFER_TEST_IDS.OFFER_VIEW.OFFER_CONSTRUCTION_PHOTOS_SECTION}>
            <ConstructionHelmetIcon wrapperColor="var(--colors-primary)" size="7" wrapperSize="8" />
            <div css={[detailConstructionBox, isProperty && propertyStyle]}>
                <div css={textContainer}>
                    <Text variant="headline_2" css={textStyle}>
                        {isMobile ? "Postępy i zdjęcia z budowy" : "Zdjęcia z budowy"}
                    </Text>
                    <Text variant="body_copy_0" css={textStyle}>
                        Zobacz na jakim etapie budowy jest ta inwestycja
                    </Text>
                </div>
                <Button
                    variant="filled_primary"
                    onClick={() => {
                        props.onButtonClick();
                    }}
                    css={buttonStyle}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.SEE_CONSTRUCTION_STEPS_BUTTON}
                >
                    Zobacz etapy budowy
                </Button>
            </div>
        </div>
    );
};

const detailConstructionSectionContainer = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: calc(var(--globals-baseUnit) * 3);
    background-color: #fff;
    border-radius: var(--globals-baseUnit);
    padding: calc(var(--globals-baseUnit) * 2);

    @media (min-width: ${theme.breakpoints.sm}) {
        flex-direction: row;
        padding: calc(var(--globals-baseUnit) * 3);
    }
`;

const detailConstructionBox = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: calc(var(--globals-baseUnit) * 3);

    @media (min-width: ${theme.breakpoints.sm}) {
        flex-direction: row;
    }
`;

const propertyStyle = css`
    @media (min-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const textContainer = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    gap: calc(var(--globals-baseUnit) * 3);

    @media (min-width: ${theme.breakpoints.sm}) {
        gap: calc(var(--globals-baseUnit) * 1);
    }
`;

const textStyle = (theme: Theme) => css`
    text-align: center;
    @media (min-width: ${theme.breakpoints.sm}) {
        text-align: left;
    }
`;

const buttonStyle = (theme: Theme) => css`
    width: 100%;
    @media (min-width: ${theme.breakpoints.sm}) {
        width: auto;
    }
`;
